import { Dispatch, SetStateAction, useRef } from 'react';
import './PDFGen.css';
import { Property } from '../../../../models/Property';
import {
  Modal,
  ModalConfig,
  ModalContent,
  ModalFooter,
  ModalPositionX,
  ModalPositionY,
  SecondaryButton,
  PrimaryButton
} from '../../../shared/modal/Modal';
import { PDFViewer, usePDF } from '@react-pdf/renderer';
import PropertyDocument from './PropertyDocument';
import { propertyNameFormatter } from '../../../../utilities/propertyUtilities';
import { fullScreen, openInNewWindow } from '../pdf-utils/pdf-modal-utils';

interface PDFGenProps {
  property: Property;
  showmodal: boolean;
  setShowModal: Dispatch<SetStateAction<boolean>>;
}

const PropertyDocumentConfig: ModalConfig = {
  title: "Summary PDF",
  showHeader: true,
  positionX: ModalPositionX.center,
  positionY: ModalPositionY.center,
  showOverlay: true
};


export default function PDFGen({ property, showmodal, setShowModal }: PDFGenProps) {
  const modalContentRef = useRef<HTMLDivElement | null>(null);
  const doc = <PropertyDocument property={property} />;
  const [instance] = usePDF({ document: doc });

  const openInNewWindowHandler = () => {
    if (instance.blob instanceof Blob) {
      openInNewWindow(instance.blob, propertyNameFormatter(property));
    }
  }

  const fullScreenHandler = () => {
    const ref = modalContentRef.current;
    fullScreen(ref);
  }

  return (
    <Modal
      show={showmodal}
      setShow={setShowModal}
      config={PropertyDocumentConfig}
      resetPdfSrc={() => {}}
    >
      <ModalContent 
        ref={modalContentRef} 
        height={'calc(100vh - 385px)'} 
        style={{ overflow: 'hidden' }}
      >
        <PDFViewer height={'100%'} width={'100%'}>
          {doc}
        </PDFViewer>
      </ModalContent>
      <ModalFooter>
        <SecondaryButton 
          title="New Window" 
          icon="esri-icon-launch-link-external"
          onClick={openInNewWindowHandler}
        />
        <PrimaryButton 
          title="Full Screen" 
          icon="esri-icon-zoom-out-fixed" 
          onClick={fullScreenHandler}
        />
      </ModalFooter>
    </Modal>
  )
}
